import { ReducerActionRotaSP } from 'store/modules/types';

import { ConsultarParametrosLocalidadeRequest, Types } from './types';

export function consultarParametrosLocalidadeRequest(
	token: string,
	data: ConsultarParametrosLocalidadeRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE,
		token,
		payload: {
			page: data.current && data.current - 1,
			size: data.limite,
			current: data.current,
			id: data.id,
			codigo: data.codigo,
			descricao: data.descricao,
			sigla: data.sigla,
			valor: data.valor,
			idLocalidade: data.idLocalidade,
			idOrgao: data.idOrgao,
		},
	};
}
export function consultarParametrosLocalidadeSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_SUCCESS,
		payload,
	};
}
export function consultarParametrosLocalidadeFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_FAILURE,
		payload: null,
	};
}
export function consultarParametrosLocalidadeClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETROS_LOCALIDADE_CLEAR,
		payload: null,
	};
}
